<template>
  <div class="xskcodeinput" @keyup.enter="upenter">
    <div class="box"  @click="focus=true" v-for="(item,index) in length" :key="index">
      <div v-if="valueVal.length>index" :style="{'bold':bold?'bold':'normal'}">{{showVal?valueVal[index]:'*'}}</div>
      <div v-if="index === 2" class="rowLine">—</div>
      <div class="line" v-if="valueVal.length==index && showLeave" style="font-size: 25px;line-height: 40px;">|</div>
    </div>
    <el-input class="input"  @focus='focusChange' @blur='blurChange' v-model="valueVal" maxlength="6"  ref="codeNum" @input="userinput" />
  </div>
</template>

<script>
export default {
  name: 'PhoneNumber',
  data() {
    return {
      focus: true,
      valueVal: '',
      showLeave: false
    }
  },
  props: {
    width: {
      type: [Number, String],
      default: 84
    },
    height: {
      type: [Number, String],
      default: 84
    },
    backgroundColor: {
      type: String,
      default: '#EDEDED'
    },
    bold: {
      type: Boolean,
      default: true
    },
    showVal: {
      type: Boolean,
      default: false
    },
    length: {
      type: Number,
      default: 6
    },
    value: {
      type: String,
      default: ''
    }
  },
  watch: {
    value: {
      handler(val) {
        this.valueVal = val
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    userinput(e) {
      this.focus = false
      this.$emit('input', this.valueVal)
    // if (this.valueVal.length === this.length) {
    //   this.$refs.codeNum.blur()
    // }
    },
    focusInput() {
      this.$refs.codeNum.focus()
    },
    upenter() {
      console.error('val')
      this.$emit('upenter')
    },
    focusChange() {
      this.showLeave = true
    },
    blurChange() {
      this.showLeave = false
    }
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>
.xskcodeinput{
  position: relative;
  width: 342px;
  .box{
    width: 42px;
    height: 42px;
    background: #ffffff;
    border: 1px solid #c4c8cc;
    border-radius: 8px;
    line-height: 42px;
    font-size: 14px;
    text-align: center;
    margin-right: 14px;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: middle;
    .line{
      opacity: 0;
      animation-name: donghua;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      animation-duration: .5s;
      animation-direction: alternate;
      color: #c4c8cc;
    }
    &:nth-child(3){
      margin-right: 34px;
      >.rowLine{
        position: absolute;
        top: 0;
        left:50%;
        font-weight: 800;
        transform: translateX(-50%);
      }
    }
    &:nth-last-child(2){
      margin-right: 0;
    }
    @keyframes donghua{
      0%{
        opacity: 1;
      }
      100%{
        opacity: 0;
      }
    }
  }

  .input{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
}
</style>
